// Utils & misc
import cn from '../../../utils/cn';

// Styles
import styles from './DateRangePickerInput.module.css';

// Components
import Picto from '../../atoms/Picto/Picto';

/**
 * DateRangePickerInput component - Simple input button for date selection
 * @param {object} props
 * @param {React.ReactNode} props.children - The content to display (formatted date)
 * @param {boolean} props.isFocused - Whether this input is currently focused
 * @param {() => void} props.onClick - Click handler
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} DateRangePickerInput component
 */
function DateRangePickerInput({
  children,
  isFocused,
  onClick,
  className,
}) {
  return (
    <button
      type="button"
      className={cn([
        styles['picker-input'],
        isFocused && styles['picker-input-focused'],
        className,
      ])}
      onClick={onClick}
    >
      <span className={styles['picker-input-label']}>
        {children}
      </span>
      <Picto icon="calendar" />
    </button>
  );
}

export default DateRangePickerInput;
